<script lang="ts"></script>

<!-- The Copista stamp: a tilted, double-ruled frame around a C. The app icon draws the same shape. -->
<svg class="mark" width="28" height="28" viewBox="0 0 32 32" aria-hidden="true">
  <g transform="rotate(-8 16 16)" fill="none" stroke="currentColor" stroke-linecap="round">
    <rect x="4" y="4" width="24" height="24" rx="2" stroke-width="2.5" />
    <rect x="7.5" y="7.5" width="17" height="17" rx="1" stroke-width="1" />
    <path d="M19.4 12.6a4.8 4.8 0 1 0 0 6.8" stroke-width="2.75" />
  </g>
</svg>
